import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from '../../app.service';
import { SecureApi } from '../../core/secure.api';

@Injectable()
export class MeAppointmentService {
    constructor(
        public http: HttpClient,
        public secureApi: SecureApi,
        public translate : TranslateService,
        public appService: AppService,
        @Inject('storyBlokToken') public storyBlokToken: string,
    ) {
    }

    getTherapists() {
        return this.secureApi.get('b2c-appointments/therapists');
    }

    getTherapistById(id) {
        return this.secureApi.get('b2c-appointments/therapist-services/' + id);
    }

    createBooking(cituroId) {
        return this.secureApi.post('b2c-appointments/create', {
            cituro_id : cituroId,
        }, false);
    }

    getTherapistStoryBlok(cituroId) {
        let lang = this.translate.currentLang;
        let storyBlokLang = 'de';
        this.appService.meLanguages.forEach(language => {
            if (language.locale == lang) {
                storyBlokLang = language.code.toLocaleLowerCase();
            }
        });

        let url = 'https://api.storyblok.com/v2/cdn/stories/?token=' + this.storyBlokToken + '&filter_query[cituroId][in]=' + cituroId + '&language=' + storyBlokLang;
        return this.http.get(url);
    }
}
